import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "waveform" }

import { onMounted, ref, watch } from 'vue'
import { CssColours } from '@/static/colours'


export default /*#__PURE__*/_defineComponent({
  __name: 'Waveform',
  props: {
    audioBufferWaveformData: null
  },
  setup(__props: any) {

const props = __props as {
  audioBufferWaveformData: Float32Array
};

const waveformCanvas = ref<HTMLCanvasElement | null>(null)
const waveformWidth = ref<number>(0)



onMounted(() => {
  if (waveformCanvas.value && props.audioBufferWaveformData) {
    draw(normalizeData(audioData(props.audioBufferWaveformData)))
    waveformWidth.value = waveformCanvas.value.offsetWidth
    waveformObserver.observe(waveformCanvas.value)
  }
})

watch(() => props.audioBufferWaveformData, () => {
  if (props.audioBufferWaveformData) {
    draw(normalizeData(audioData(props.audioBufferWaveformData)))
  }
})

// Handle resizing
// Redraw if waveform has gotten wider
const waveformObserver = new ResizeObserver((entries) => {
  for (const entry of entries) {
    if (entry.contentRect.width !== waveformWidth.value) {
      // Clear canvas
      clearCanvas()
      if (props.audioBufferWaveformData) {
        draw(normalizeData(audioData(props.audioBufferWaveformData)))
        waveformWidth.value = entry.contentRect.width
      }
    }
  }
  
})

const clearCanvas = () => {
  if (waveformCanvas.value) {
    const ctx = waveformCanvas.value.getContext('2d')
    if (ctx) {
      ctx.clearRect(0, 0, waveformCanvas.value.width, waveformCanvas.value.height)
    }
  }
}

const audioData = (rawData: Float32Array) => {
  let samples = 300
  if (waveformCanvas.value) {
    // Number of samples we want to have in our final data set, we want a 6px space per datapoint
    samples = Math.floor(waveformCanvas.value.offsetWidth / 6)
  }
  const blockSize = Math.floor(rawData.length / samples) // Number of samples in each block
  const filteredData = []
  for (let i = 0; i < samples; i++) {
    let blockStart = blockSize * i // the location of the first sample in the block
    let sum = 0
    for (let j = 0; j < blockSize; j++) {
      sum = sum + Math.abs(rawData[blockStart + j]) // find the sum of all the samples in the block
    }
    filteredData.push(sum / blockSize) // get the average across the block
  }
  return filteredData
}

const normalizeData = (filteredData: number[]) => {
  const multiplier = Math.pow(Math.max(...filteredData), -1)
  return filteredData.map(n => n * multiplier)
}

const draw = (audioData: number[]) => {
  // Set up the canvas
  if (waveformCanvas.value) {
    const dpr = window.devicePixelRatio || 1
    const boundingRect = waveformCanvas.value.getBoundingClientRect()
    // Give the canvas pixel dimensions of their CSS
    waveformCanvas.value.width = boundingRect.width * dpr
    waveformCanvas.value.height = 52 * dpr // Waveform should always be a perceptible 60px tall
    const ctx = waveformCanvas.value.getContext('2d')
    if (ctx) {
      ctx.scale(dpr, dpr)
      ctx.translate(0, waveformCanvas.value.offsetHeight / 2) // Set Y = 0 to be in the middle of the canvas

      const width = (waveformCanvas.value.offsetWidth - (audioData.length * 2)) / audioData.length 
      for (let i = 0; i < audioData.length; i++) {
        const x = width * i + (i * 2)
        let height = audioData[i] * (waveformCanvas.value.offsetHeight / 2)
        height = Math.max(height, 1)
        height = Math.min(height, waveformCanvas.value.offsetHeight / 2)
        drawSegment(ctx, x, height * 2, width)
      }
    } else {
      throw new Error('no ctx')
    }
  }
}
const drawSegment = (ctx: CanvasRenderingContext2D, x: number, height: number, width: number) => {
  ctx.fillStyle = CssColours.WAVEFORM_HOVER_PURPLE
  ctx.beginPath()
  ctx.roundRect(x, -(height / 2), width, height, 52) // y is based in the middle of the waveform
  ctx.fill()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", {
      ref_key: "waveformCanvas",
      ref: waveformCanvas,
      id: "waveform",
      height: "52",
      width: "500"
    }, null, 512)
  ]))
}
}

})